
import UMUM from "../../library/umum";

export default {
  data() {
    return {
      form: {
        id: "",
        tahun: "",
        indikator: "",
        kecamatan: "",
        a: 0,
        b: 0,
        nama: "",
        jenis: "",
        uraian: "",
        nib: "",
        deskripsi: "",
        keterangan: "",
        createAt: "",
        editedAt: "",
      },

      tahun: "",
      sumber: "",
      kendala: "",
      total1: "",
      total2: "",
      total3: "",
      total4: "",
      total5: "",
      total6: "",
      total7: "",
      total8: "",
      indikator: "",
      nama_tahun: "",
      nama_kadis: "",
      nip_kadis: "",
      pangkat_kadis: "",
      gol_kadis: "",
      ruang_kadis: "",
      gel_bel_kadis: "",
      gel_dep_kadis: "",

      list_data: [],
      cetak_data: [],
      list_tahun: [],
      list_kecamatan: [],
      list_indikator: [],

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data: true,

      mdl_add: false,
      mdl_cetak: false,
      mdl_print: false,
      mdl_download: false,
      mdl_edit: false,
      mdl_hapus: false,
      btn_add: false,

      UMUM: UMUM,
    };
  },
  computed: {
    // subTotalCols() {
    //   const cols = this.indikatorSchema.table.sumColumns;
    //   const rows = this.normalizedCetakRows;

    //   const totals = {};

    //   cols.forEach((c) => (totals[c] = 0));

    //   rows.forEach((r) => {
    //     cols.forEach((c) => {
    //       totals[c] += Number(r[c] || 0);
    //     });
    //   });

    //   return totals;
    // },

    nonSumColCount() {
    const body = this.indikatorSchema.table.bodyColumns
    const sumCols = this.indikatorSchema.table.sumColumns || []

    let count = 0

    for (let col of body) {
      if (sumCols.includes(col) || col === 'percentage') {
        break
      }
      count++
    }

    return count
  },

    subTotalCols() {
      const cols = this.indikatorSchema.table.sumColumns;
      const rows = this.normalizedCetakRows;

      const totals = {};

      cols.forEach((c) => (totals[c] = 0));

      rows.forEach((r) => {
        cols.forEach((c) => {
          totals[c] += Number(r[c] || 0);
        });
      });

      // 👉 Hitung percentage dari total A dan total B
      let percentage = 0;

      const id = this.form?.indikator?.id;

      if (id == 1) {
        percentage =
          totals.b > 0 ? ((totals.a / totals.b) * 100).toFixed(2) : 0;
      } else if (id == 10 || id == 12) {
        percentage =
          totals.a > 0
            ? ((totals.b / totals.a) * 100).toFixed(2)
            : 0;
      } else if (id == 16) {
        const numerator = totals.a + totals.b + totals.c;
        const denominator = totals.d + totals.e + totals.f;

        percentage =
          denominator > 0 ? ((numerator / denominator) * 100).toFixed(2) : 0;
      } else if (id == 26) {
        const numerator = totals.c + totals.d;
        const denominator = totals.a + totals.b;

        percentage =
          denominator > 0 ? ((numerator / denominator) * 100).toFixed(2) : 0;
      } else {
        percentage =
          totals.b > 0 ? ((totals.a / totals.b) * 100).toFixed(2) : 0;
      }

      totals.percentage = percentage;

      return totals;
    },

    grandTotal() {
      const cols =
        this.indikatorSchema.table.sumColumns ||
        this.indikatorSchema.table.bodyColumns;
      return cols.reduce(
        (sum, c) => sum + Number(this.subTotalCols[c] || 0),
        0,
      );
    },
    indikatorSchema() {
      const id = Number(this.form?.indikator?.id);

      // helper cepat
      const num = (v) => Number(v || 0);

      const isCetak = this.mdl_cetak;

      // =========================
      // INDIKATOR 1
      // =========================
      if (id === 1) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kecamatan" },
                { label: "Jumlah Pemuda Usia (16-30) Tahun Yang Berwirausaha" },
                { label: "Target Pemuda Usia (16-30) Tahun Yang Mendapatkan Pembinaan Wirausaha" },
                { label: "Persentase (%)" },
                { label: "Keterangan" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["kecamatan", "a", "b", "percentage", "keterangan"],
            sumColumns: ["a", "b"],
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  { key: "a",
                    label: "Jumlah Pemuda Usia (16-30) Tahun Yang Berwirausaha",
                    type: "number",
                  },
                  { key: "b",
                    label: "Jumlah Pemuda Usia (16-30) Tahun Yang Mendapatkan Pembinaan Wirausaha",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: b > 0 ? ((a / b) * 100).toFixed(2) : 0,
            };
          },
        };
      }
      // =========================
      // INDIKATOR 2
      // =========================
      if (id === 2) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama" },
                { label: "Usia" },
                { label: "Jenis Usaha" },
                { label: "Bidang Usaha" },
                { label: "Alamat Tempat Usaha" },
                { label: "Nomor Induk Berusaha (NIB)" },
                { label: "Ket" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["nama", "a", "jenis", "uraian", "deskripsi", "nib", "keterangan"],
            sumColumns: ["a"],
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 2,
                fields: [
                  { key: "nama",
                    label: "Nama",
                    type: "text",
                  },
                  { key: "a",
                    label: "Usia",
                    type: "number",
                  },
                  { key: "jenis",
                    label: "Jenis Usaha",
                    type: "text",
                  },
                  { key: "uraian",
                    label: "Bidang Usaha",
                    type: "text",
                  },
                  { key: "deskripsi",
                    label: "Alamat Tempat Usaha",
                    type: "text",
                  },
                  { key: "nib",
                    label: "Nomor Induk Berusaha (NIB)",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a) + ' tahun';

            return {
              ...row,
              a,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 3
      // =========================
      if (id === 3) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 3, width: "5%" },
                { label: "Jenis Organisasi", colspan: 4 },
                { label: "Ket", rowspan: 3 },
                ...(!isCetak ? [{ label: "", rowspan: 3, width: "7%" }] : []),
              ],
              [
                { label: "Kepemudaan", colspan: 2 },
                { label: "Sosial Kemasyarakatan", colspan: 2 },
              ],
              [
                { label: "Nama Organisasi" },
                { label: "Jumlah Anggota Aktif (Usia 16-30 Tahun)" },
                { label: "Nama Organisasi" },
                { label: "Jumlah Anggota Aktif (Usia 16-30 Tahun)" },
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["nama", "a", "uraian", "b", "keterangan"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title: "Kepemudaan",
                cols: 2,
                fields: [
                  {
                    key: "nama",
                    label: "Nama Organisasi",
                    type: "text",
                  },
                  {
                    key: "a",
                    label: "Jumlah Anggota Aktif (Usia 16-30 Tahun)",
                    type: "number",
                  },
                ],
              },
              {
                title: "Sosial Kemasyarakatan",
                cols: 2,
                fields: [
                  {
                    key: "uraian",
                    label: "Nama Organisasi",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Jumlah Anggota Aktif (Usia 16-30 Tahun)",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 4
      // =========================
      if (id === 4) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2 },
                { label: "Jumlah Pemuda Usia (16-30)", colspan: 2 },
                { label: "Jumlah", rowspan: 2 },
                { label: "Ket", rowspan: 2 },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Laki-Laki" },
                { label: "Perempuan" },
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["kecamatan", "a", "b", "total", "keterangan"],
            sumColumns: ["a", "b", "total"],
            showTotal: false,
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title: "Jumlah Pemuda Usia (16-30)",
                cols: 2,
                fields: [
                  {
                    key: "a",
                    label: "Laki-Laki",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Perempuan",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              total: a + b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 5
      // =========================
      if (id === 5) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama Lengkap" },
                { label: "Jenis Kelamin" },
                { label: "Usia" },
                { label: "Kedudukan / Jabatan Dalam Organisasi" },
                { label: "Nomor Identitas Anggota" },
                { label: "Keterangan" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["nama","b","a","uraian", "nib", "keterangan"],
            sumColumns: ["a"],
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  { key: "nama",
                    label: "Nama Lengkap",
                    type: "text",
                  },
                ],
              },
              {
                cols: 2,
                fields: [
                  {
                    key: "b",
                    label: "Jenis Kelamin",
                    type: "select",
                    options: [
                      { label: "Laki-Laki", value: 1 },
                      { label: "Perempuan", value: 0 }
                    ]
                  },
                  { key: "a",
                    label: "Usia",
                    type: "number",
                  },
                  { key: "uraian",
                    label: "Kedudukan/Jabatan Dalam Organisasi",
                    type: "text",
                  },
                  { key: "nib",
                    label: "Nomor Identitas Anggota",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a) + ' tahun';
            const b = row.b == 1 ? "Laki Laki" : "Perempuan";

            return {
              ...row,
              a,
              b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 6
      // =========================
      if (id === 6) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama" },
                { label: "Cabang Olahraga" },
                { label: "Lembaga Pembina" },
                { label: "Kecamatan" },
                { label: "No SK Pemanggilan Pengurus Provinsi Cabang Olahraga/Dinas Kepemudaan dan Olahraga Provinsi / KONI Provinsi" },
                { label: "Ket", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["nama", "jenis","uraian","kecamatan","nib","keterangan"],
            sumColumns: ["a"],
            showTotal: false,
            showSubTotal: false,
            showGrandTotal: false,
            showKet: false,
            showAksi: !isCetak,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "nama",
                    label: "Nama",
                    type: "text",
                  },
                ],
              },
              {
                cols: 2,
                fields: [
                  {
                    key: "jenis",
                    label: "Cabang Olahraga",
                    type: "text",
                  },
                  {
                    key: "uraian",
                    label: "Lembaga Pembina",
                    type: "text",
                  },
                ],
              },
              {
                cols: 1,
                fields: [
                  {
                    key: "nib",
                    label: "No SK Pemanggilan Pengurus Provinsi Cabang Olahraga/Dinas Kepemudaan dan Olahraga Provinsi / KONI Provinsi",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);

            return {
              ...row,
              a,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 7
      // =========================
      if (id === 7) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama" },
                { label: "Jenis Kelamin" },
                { label: "Cabang Olahraga" },
                { label: "Kecamatan" },
                { label: "Lembaga Pembina" },
                { label: "Ket" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["nama","b","jenis", "kecamatan", "uraian", "keterangan"],
            sumColumns: ["a"],
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 2,
                fields: [
                  { key: "nama",
                    label: "Nama Lengkap",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Jenis Kelamin",
                    type: "select",
                    options: [
                      { label: "Laki-Laki", value: 1 },
                      { label: "Perempuan", value: 0 }
                    ]
                  },
                  { key: "jenis",
                    label: "Cabang Olahraga",
                    type: "text",
                  },
                  { key: "uraian",
                    label: "Lembaga Pembina",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = row.b == 1 ? "Laki Laki" : "Perempuan";

            return {
              ...row,
              a,
              b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 8
      // =========================
      if (id === 8) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama" },
                { label: "Jenis Kelamin" },
                { label: "Cabang Olahraga" },
                { label: "Kecamatan" },
                { label: "Nama Kejuaraan" },
                { label: "Jenis Event" },
                { label: "Perolehan Medali" },
                { label: "Ket" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["nama","b","jenis", "kecamatan", "uraian", "deskripsi", "nib", "keterangan"],
            sumColumns: ["a"],
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 2,
                fields: [
                  { key: "nama",
                    label: "Nama Lengkap",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Jenis Kelamin",
                    type: "select",
                    options: [
                      { label: "Laki-Laki", value: 1 },
                      { label: "Perempuan", value: 0 }
                    ]
                  },
                  { key: "jenis",
                    label: "Cabang Olahraga",
                    type: "text",
                  },
                  { key: "uraian",
                    label: "Nama Kejuaraan",
                    type: "text",
                  },
                  { key: "deskripsi",
                    label: "Jenis Event",
                    type: "text",
                  },
                  { key: "nib",
                    label: "Perolehan Medali",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = row.b == 1 ? "Laki Laki" : "Perempuan";

            return {
              ...row,
              a,
              b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 9
      // =========================
      if (id === 9) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama" },
                { label: "Jenis Kelamin" },
                { label: "Cabang Olahraga" },
                { label: "Kecamatan" },
                { label: "Nama Kejuaraan" },
                { label: "Jenis Event" },
                { label: "Ket" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["nama","b","jenis", "kecamatan", "uraian", "deskripsi", "keterangan"],
            sumColumns: ["a"],
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 2,
                fields: [
                  { key: "nama",
                    label: "Nama Lengkap",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Jenis Kelamin",
                    type: "select",
                    options: [
                      { label: "Laki-Laki", value: 1 },
                      { label: "Perempuan", value: 0 }
                    ]
                  },
                ],
              },
              {
                cols: 3,
                fields: [
                  { key: "jenis",
                    label: "Cabang Olahraga",
                    type: "text",
                  },
                  { key: "uraian",
                    label: "Nama Kejuaraan",
                    type: "text",
                  },
                  { key: "deskripsi",
                    label: "Jenis Event",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = row.b == 1 ? "Laki Laki" : "Perempuan";

            return {
              ...row,
              a,
              b,
            };
          },
        };
      }

      // =========================
      // DEFAULT
      // =========================
      return {
        id,
        table: {
          headRows: [],
          bodyColumns: [],
          showTotal: false,
          showKet: false,
          showAksi: !isCetak,
        },
        form: {
          groups: [],
          showKet: false,
        },
        calcRow: (row) => row,
      };
    },

    // ini dipakai untuk table view
    normalizedRows() {
      return (this.list_data || []).map(this.indikatorSchema.calcRow);
    },

    // ini dipakai untuk cetak
    normalizedCetakRows() {
      return (this.cetak_data || []).map(this.indikatorSchema.calcRow);
    },
  },

  methods: {
    getCellValue(row, key) {
      return row[key] ?? 0;
    },
    formatDate(val) {
      if (!val) return "-";

      const d = new Date(val);
      if (isNaN(d)) return val;

      return d.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    getView: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DISPORA + "viewData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log("dasf");

          console.log(res_data);
          console.log("dasf");
          this.list_data = res_data.data;
          this.cetak_data = res_data.cetak;
          this.page_last = res_data.jml_data;
          this.$store.commit("hideLoading");
          this.nama_tahun = res_data.data[0].thn;
          this.indikator = res_data.data[0].indikator;
        });
    },

    getTotal: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_TOTAL + "DISPORAData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.$store.commit("hideLoading");
          this.total1 = res_data.data[0].total1;
          this.total2 = res_data.data[0].total2;
          this.total3 = res_data.data[0].total3;
          this.total4 = res_data.data[0].total4;
          this.total5 = res_data.data[0].total5;
          this.total6 = res_data.data[0].total6;
          this.total7 = res_data.data[0].total7;
          this.total8 = res_data.data[0].total8;
          console.log(res_data);
        });
    },

    getKadis: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Unit + "kadis", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.nama_kadis = res_data[0].nama;
          this.nip_kadis = res_data[0].nip;
          this.pangkat_kadis = res_data[0].pangkat;
          this.gol_kadis = res_data[0].gol;
          this.ruang_kadis = res_data[0].ruang;
          this.gel_dep_kadis = res_data[0].gelar_depan;
          this.gel_bel_kadis = res_data[0].gelar_belakang;
          this.$store.commit("hideLoading");
        });
    },

    getKecamatan: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Kecamatan + "view", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_kecamatan = res_data;

          console.log(this.list_kecamatan);
          this.$store.commit("hideLoading");
        });
    },

    getTahun: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Tahun, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_tahun = res_data;
          this.$store.commit("hideLoading");
        });
    },

    getIndikator: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DISPORA + "indikator", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_indikator = res_data;
          this.$store.commit("hideLoading");
        });
    },
    printTable() {
      const printWindow = window.open("", "_blank");
      const content = document.getElementById("printCetak").innerHTML;

      const style = `
    <style>
      @page { margin: 10mm; }

      body {
        font-family: Arial, sans-serif;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        margin: 0;
        padding: 0;
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        border: 1px solid #ddd;
        padding: 5px;
        font-size: 11px;
        word-break: break-word;
        white-space: normal;
      }

      .text-center {
        text-align: center !important;
      }

      .print-wrapper {
        transform-origin: top left;
        display: inline-block;
      }
    </style>
  `;

      printWindow.document.open();
      printWindow.document.write(`
    <html>
      <head>
        <title>Dinas Kepemudaan dan Olahraga</title>
        ${style}
      </head>
      <body>
        <div id="wrapper" class="print-wrapper">
          ${content}
        </div>
      </body>
    </html>
  `);
      printWindow.document.close();

      printWindow.onload = function () {
        const wrapper = printWindow.document.getElementById("wrapper");

        // lebar halaman yang sedang aktif (portrait/landscape ikut user)
        const pageWidth = printWindow.innerWidth;

        // lebar tabel / konten
        const contentWidth = wrapper.scrollWidth;

        if (contentWidth > pageWidth) {
          const scale = pageWidth / contentWidth;
          wrapper.style.transform = `scale(${scale})`;
        } else {
          wrapper.style.transform = "scale(1)";
        }

        printWindow.focus();
        printWindow.print();
      };
    },
    addData: function () {
      // var formData = new FormData();
      // formData.append('data', JSON.stringify(this.form))
      fetch(this.$store.state.url.URL_DISPORA + "addData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menambah Data",
          "light-blue-4",
          "check_circle_outline",
        );
        console.log(res_data);
        this.getView();
      });
    },

    editData: function () {
      console.log(this.form);
      fetch(this.$store.state.url.URL_DISPORA + "editData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify("Sukses Merubah Data", "lime-7", "check_circle_outline");
        this.getView();
      });
    },

    removeData: function (a) {
      fetch(this.$store.state.url.URL_DISPORA + "removeData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({ id: a }),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menghapus Data",
          "deep-orange-10",
          "check_circle_outline",
        );
        this.getView();
      });
    },

    selectData: function (data) {
      this.form.id = data.id;
      this.form.nama = data.nama;
      this.form.kecamatan = data.kecamatan;
      this.form.jenis = data.jenis;
      this.form.uraian = data.uraian;
      this.form.deskripsi = data.deskripsi;
      this.form.nib = data.nib;
      this.form.a = data.a;
      this.form.b = data.b;
      this.form.keterangan = data.keterangan;
      this.form.createAt = data.createAt;
    },

    // ====================================== PAGINATE ====================================
    Notify: function (message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500,
      });
    },
    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },

    // ====================================== PAGINATE ====================================
  },

  mounted() {
    this.getView();
    this.getTahun();
    this.getKadis();
    this.getIndikator();
    this.getKecamatan();
  },
};
